import { forwardRef } from 'react';
import { Tooltip } from 'ui/tooltip';
import { SelectValueType } from 'ui/selects';
import { isEmptyString } from 'utils/stringHelpers';
import { doesExist, isDefined, isString } from 'utils/tsHelpers';
import { useQueryBuilderSelectTooltipContent } from './hooks';
import { SelectTriggerProps } from '../types';
import { TriggerButton } from '../TriggerButton';
import { EllipsizedContent } from '../ConditionInput/ConditionInput.styles';

export const QueryBuilderSelectTrigger = forwardRef<
  HTMLButtonElement,
  SelectTriggerProps<SelectValueType>
>(
  (
    {
      DefaultIcon = null,
      isDisabled: isTriggerDisabled,
      isLoading = false,
      options = [],
      placeholder = '',
      selectedOptions = [],
      suffixUsed,
      toggleDropdown,
      ...props
    },
    ref,
  ) => {
    const { Suffix, label, Prefix } = selectedOptions[0] ?? {};
    const value = suffixUsed && isDefined(Suffix) ? Suffix : label;
    const content = value ?? placeholder;
    const { tooltipContent, isEnabled } = useQueryBuilderSelectTooltipContent(value, options);
    const isEmpty = (isString(value) && isEmptyString(value)) || !doesExist(value);
    const isDisabled = isTriggerDisabled || options.length === 0;
    const Icon = Prefix ?? DefaultIcon;

    return (
      <Tooltip tooltipContent={tooltipContent} isEnabled={isEnabled}>
        <TriggerButton
          innerRef={ref}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isEmpty={isEmpty}
          onClick={() => toggleDropdown()}
          {...props}
        >
          {Icon}
          <EllipsizedContent>{content}</EllipsizedContent>
        </TriggerButton>
      </Tooltip>
    );
  },
);
